// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

let domain_name = document.domain.includes('localhost') ? 'http://localhost:3000/cable' : 'https://legacy.constructoye.com/cable'

export default createConsumer(domain_name)
